import React, {useEffect, useState} from 'react';
import './onboard-question-style.scss';
import {useTranslation} from "react-i18next";

const QuestionTextComponent = (props) => {
    const {t} = useTranslation();
    const {select, label, value} = props;
    const LIMIT = 280;

    const [text, setText] = useState("");
    const [count, setCount] = useState(0);

    const handleChange = (value) => {
        if (value === null) return;
        if (value.length > LIMIT) return;
        setText(value);
        select(value);
        setCount(value.length);
    }

    useEffect(() => {
        if (value !== undefined)
            handleChange(value);
    }, [value])

    return (
        <div className="question-text-root">
            <textarea onChange={(val) => handleChange(val.target.value)} className="question-text-textarea"
                      value={text}
                      placeholder={t('feedback.your_message')}></textarea>
            {label && (<p className="question-text-label">{label}</p>)}
            <p className="question-text-count">{count} / {LIMIT}</p>
        </div>
    )
};

export default QuestionTextComponent;
